module.exports = __webpack_public_path__ + "img/h4b_logo_big_white.8a01e64b.png";